import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function usePermissionOptions() {
    const { data: permissionsOptions, isPlaceholderData: isPlaceholderDataPermissionsOptions } =
        useQuery({
            queryKey: ['permissions-options'],
            queryFn: async () => {
                const { data } = await axios.get(route('v2.roles.permissions.options'));
                return data;
            },
            placeholderData: [],
        });

    return {
        permissionsOptions,
        isPlaceholderDataPermissionsOptions,
    };
}
